export const QwInputSearchModeEnum = {
	TOGGLE: "toggle",
	ACTION: "action",
}
